var render, staticRenderFns
import script from "./BaseSplitterPanel.vue?vue&type=script&lang=js&"
export * from "./BaseSplitterPanel.vue?vue&type=script&lang=js&"
import style0 from "./BaseSplitterPanel.vue?vue&type=style&index=0&id=35579ab8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports